import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ONBOARDING_REDIRECT_TO_AFTER_COMPLETE_KEY } from '@/constants/router';

interface UseOnboardingCompleteRedirectOptions {
  followExternal?: boolean;
}

const isInternalPath = (redirectTo: string) => redirectTo.startsWith('/');

export const useOnboardingCompleteRedirect = (isLoading: boolean, { followExternal = true }: UseOnboardingCompleteRedirectOptions = {}) => {
  const navigate = useNavigate();

  // Captured on mount: the effect clears the key, but callers must keep withholding content until the page has actually left.
  const [isRedirecting] = useState(() => {
    const redirectTo = window.sessionStorage.getItem(ONBOARDING_REDIRECT_TO_AFTER_COMPLETE_KEY);

    return !!redirectTo && (isInternalPath(redirectTo) || followExternal);
  });

  useEffect(() => {
    if (isLoading) return;

    const redirectTo = window.sessionStorage.getItem(ONBOARDING_REDIRECT_TO_AFTER_COMPLETE_KEY);
    if (!redirectTo) return;

    window.sessionStorage.removeItem(ONBOARDING_REDIRECT_TO_AFTER_COMPLETE_KEY);

    if (isInternalPath(redirectTo)) {
      navigate(redirectTo, { replace: true });

      return;
    }

    if (followExternal) window.location.replace(redirectTo);
  }, [isLoading, navigate, followExternal]);

  return { isRedirecting };
};
